module.exports = __webpack_public_path__ + "img/Speaker=Eddie Wang.b4a45219.png";